import { useMutation } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

export type ReviewAction = "publish" | "unpublish" | "flag" | "resolve" | "forward";
const TITLES: Record<ReviewAction, string> = {
  publish: "Published to the yacht page",
  unpublish: "Taken off the yacht page",
  flag: "Flagged for follow-up — held off the public page",
  resolve: "Follow-up resolved",
  forward: "Forwarded to the crew",
};

export const useBookingReviewAction = (bookingId: string, onDone: () => void) => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: ({ action, reason }: { action: ReviewAction; reason?: string }) =>
      fetch<{ data: any }>(`/api/bookings/${bookingId}/review/${action}`, "POST", reason ? { reason } : undefined),
    onSuccess: (res: any, v) => {
      const d = res?.data;
      toast({
        title: v.action === "forward" && d?.redirected ? "Test copy sent to you" : TITLES[v.action],
        description:
          v.action === "forward" && d?.to
            ? d.redirected
              ? `Outside production this goes to you, not the crew — it would go to ${d.wouldGoTo}.`
              : `Sent to ${d.to}.`
            : undefined,
      });
      onDone();
    },
    onError: (error: any) =>
      toast({ title: "Couldn't do that", description: error?.message || "The action failed.", variant: "destructive" }),
  });
};
